function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import tscStyles from '../constants/TscStyles';
import { getClassName } from '../utils/get-class-name';
var Container = styled.div.withConfig({
  displayName: "StatusIndicator__Container"
})(["display:flex;justify-content:center;align-items:center;min-width:5rem;width:100%;height:100%;"]);
var Progress = styled.progress.withConfig({
  displayName: "StatusIndicator__Progress"
})(["-webkit-appearance:none;-moz-appearance:none;appearance:none;flex:1 1 auto;height:100%;color:", ";border:none;min-width:0;::-webkit-progress-bar{background-color:", "}::-webkit-progress-value{background-color:", ";}::-moz-progress-bar{background-color:", ";}::-ms-fill{border:none;}"], function (props) {
  return props.color;
}, tscStyles.color.text.lightMedium, function (props) {
  return props.color;
}, function (props) {
  return props.color;
});
var CountContainer = styled.div.withConfig({
  displayName: "StatusIndicator__CountContainer"
})(["flex:0 0 auto;min-width:3rem;margin-left:.5rem;text-align:center;"]);
var defaultProps = {
  cautionCount: 0,
  warningCount: 0
};

var StatusIndicator = function StatusIndicator(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      cautionCount = _defaultProps$props.cautionCount,
      className = _defaultProps$props.className,
      max = _defaultProps$props.max,
      style = _defaultProps$props.style,
      value = _defaultProps$props.value,
      warningCount = _defaultProps$props.warningCount; // overlay the defaultProps and passed in props in logical order and spread to constant values


  var color;
  var showCaution = cautionCount !== 0 ? value >= cautionCount : value >= max - 1;
  var showWarning = warningCount !== 0 ? value >= warningCount : value >= max;

  if (showWarning) {
    color = tscStyles.color.message.warning;
  } else if (showCaution) {
    color = tscStyles.color.message.caution;
  } else {
    color = tscStyles.color.message.affirmative;
  } // Note - Progress max must come before value or IE11 and Edge will not render the initial content correctly


  return _jsxs(Container, {
    className: getClassName(className, null, 'status-indicator-container'),
    style: style,
    children: [_jsx(Progress, {
      className: getClassName(className, 'progress'),
      max: max,
      value: value,
      color: color
    }), _jsxs(CountContainer, {
      className: getClassName(className, 'count-container'),
      children: [value, "/", max]
    })]
  });
};

StatusIndicator.defaultProps = defaultProps;
var StatusIndicatorTest = {
  Container: Container,
  Progress: Progress
};
export { StatusIndicator, StatusIndicatorTest };
export default StatusIndicator;